import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StatoRiparazione } from '../models/stato-riparazione';
import { ResourcefulService } from './resourcefulService';



@Injectable({
  providedIn: 'root'
})
export class StatoRiparazioneService extends ResourcefulService<StatoRiparazione>{
  constructor(private httpClient: HttpClient) {
    super(httpClient, StatoRiparazione);
  }
}
